import axios from '@/utils/request.js'
import { buildReqDeviceInfo } from '@/utils/user-verify-helper.js'

// 地区列表
export function getAreaList() {
  return axios.get(`/v1/account/ol/regionList`)
}

// 登录页获取验证码 / 首次设置登录密码
export function getVerifyCode(countryCode, phone, code, type = 16, channelCode = '') {
  // type: 验证码类型；1 注册； 2 忘记密码 3 重设交易密码 4 修改手机号码-验证老手机 5 修改手机号码-验证新手机 6 银行卡绑定验证 7 盈宝币提现 8 手机验证码登录/注册 9 首次设置密码
  // 16: h5登录注册
  const params = {
    countryCode: countryCode,
    phone: phone,
    code: code,
    type: type
  }
  if (channelCode) {
    params.channelCode = channelCode
  }
  return axios.post('/v1/user/code/gen', params)
}

// 手机验证码登录
export async function doLoginByCode(params) {
  return axios.post('/v1/user/code-login', params)
}

// 校验微信code
export async function verifyWechatCode(wechatCode) {
  return axios.get(`/v1/user/verifyWechatCode?wechatCode=${wechatCode}`)
}

// 手机验证码登录 - 公众号绑定
export async function doLoginWithWechat(params) {
  return axios.post('/v1/user/wechatLoginAndBind', params)
}

// 获取国家地区
export function getNationList() {
  return axios.get('/v1/account/ol/regionList')
}

// 解码渠道信息
export function decodeChannelInfo(code) {
  return axios.get(`/v1/user/channel/decode/${code}`)
}

// 获取基础数据
export async function getBaseData() {
  const deviceInfo = await buildReqDeviceInfo(true)
  return axios.get('/v1/user/sys/data', {
    headers: {
      'Device-Info': deviceInfo
    }
  })
}

// 获取开户状态
export function getAccountStatus() {
  return axios.get(`/v1/account/ol/accountStatus`)
}

// 未设置密码，首次修改密码
export function firstModifyPassword(params) {
  return axios.post(`/v1/user/password/first-set`, params)
}

// 获取用户信息
export function getUserInfo() {
  return axios.get(`/v1/user/profile`)
}

// 获取活动内容
export function getActivityInfo(id) {
  return axios.get(`/v1/marketing/activity/detail/${id}`)
}

// 领取奖励
export function receiveAward(id) {
  return axios.post(`/v1/marketing/activity/receiveAward/${id}`)
}
// 领取奖励(新)
// 10001 活动无效
// 10002 用户未参加，不满足活动条件
// 10003 用户已参加活动
// 10004 用户已入金，包括转入股票
export function newReceiveAward(id) {
  return axios.post(`/v1/marketing/activity/newReceiveAward/${id}`)
}

// 查询当前IP所在区域
export function getLocation() {
  return axios.get(`/v1/user/location`)
}

// 活动 - 绑定邀请人
export function activityBindInviter(params) {
  return axios.post(`/v1/marketing/activity/invite`, params)
}

// 活动 - 获取活动邀请人数及奖励内容
export function getActivityInviteReward(activityId) {
  return axios.get(`/v1/marketing/activity/inviteReward?activityId=${activityId}`)
}

// 活动 - 获取我的邀请
export function getActivityMyInviteUser(activityId, pageIndex = 1, pageSize = 99999) {
  return axios.get(
    `/v1/marketing/activity/getMyInviteUser?activityId=${activityId}&pageIndex=${pageIndex}&pageSize=${pageSize}`
  )
}

// 活动 - 获取活动邀请排行榜及奖励信息
export function getActivityInviteRank(activityId, pageIndex = 1, pageSize = 6) {
  return axios.get(
    `/v1/marketing/activity/getInviteRank?activityId=${activityId}&pageIndex=${pageIndex}&pageSize=${pageSize}`
  )
}

// 活动 - 获取活动绑定渠道信息
export function getActivityChannel(activityId) {
  return axios.get(`/v1/marketing/activity/getActivityChannel?activityId=${activityId}`)
}

// 图形验证码生成
export function getCaptcha(code) {
  return axios.get(`/v1/universal/captcha/get?code=${code}`)
}

// 图形验证码验证
export function verifyCaptcha(params) {
  return axios.post(`/v1/universal/captcha/verify`, params)
}

// 获取帮助文章id
export function getHelpIdByType(questionInfoExplainEnum) {
  return axios.get(`/v1/consult_web/question/getExplainContent?questionInfoExplainEnum=${questionInfoExplainEnum}`)
}

// 邀请活动 - 注册并绑定邀请人
export async function inviteAndSignIn(params) {
  return axios.post('/v1/marketing/activity/inviteAndSignIn', params)
}

// 查询指定类型活动列表
// [specificActivity] ACTIVITY_INVITE("邀请好友长期活动")
export async function getSpecificActivity(specificActivity) {
  return axios.get(`/v1/marketing/activity/getSpecificActivity?specificActivity=${specificActivity}`)
}

// 查询我的邀请数据统计
// [activityType] 活动类型（4：邀请好友长期活动）
export async function getInviteDataStatistics(activityType) {
  return axios.get(`/v1/marketing/activity/getInviteDataStatistics/${activityType}`)
}

// 查询我的邀请数据列表
// [activityType] 活动类型（4：邀请好友长期活动）
export async function getInviteDataPage(params) {
  let url = '/v1/marketing/activity/getInviteDataPage'
  const activityType = params.activityType
  const pageIndex = params.pageIndex
  const pageSize = params.pageSize
  const inviteUserState = params.inviteUserState

  url += `?activityType=${activityType}`
  url += `&pageIndex=${pageIndex}`
  url += `&pageSize=${pageSize}`
  if (inviteUserState) {
    url += `&inviteUserState=${inviteUserState}`
  }
  return axios.get(url)
}

// 查询优先的好友分享链接
export async function getShareLink() {
  return axios.get(`/v1/user/channel/get_link`)
}
